import { Routes } from '@angular/router';

import { LessonIntroductionComponent } from './lesson-introduction/lesson-introduction.component';
import { LessonComponent } from './lesson.component';
import { LessonStrategyTopicComponent } from './lesson-strategy/lesson-strategy-topic/lesson-strategy-topic.component';
import { LessonStrategyHypothesisComponent } from './lesson-strategy/lesson-strategy-hypothesis/lesson-strategy-hypothesis.component';
import { LessonStrategyAnswerComponent } from './lesson-strategy/lesson-strategy-answer/lesson-strategy-answer.component';
import {
  LessonStrategyIdentificationComponent
} from './lesson-strategy/lesson-strategy-identification/lesson-strategy-identification.component';
import { exerciseRoutes } from './exercise/exercise.routes';


export const lessonRoutes: Routes = [
  {
    path: 'lessons',
    // canActivate: [AuthGuard],
    component: LessonComponent,
    children: [
      {
        path: ':lessonId',
        children: [
          {
            path: 'introduction',
            component: LessonIntroductionComponent,
            data: {
              breadcrumb: {
                currentSection: 'introduction'
              }
            }
          },
          {
            path: 'strategy-topic',
            component: LessonStrategyTopicComponent,
            data: {
              breadcrumb: {
                currentSection: 'strategy'
              }
            }
          },
          {
            path: 'strategy-hypothesis',
            component: LessonStrategyHypothesisComponent,
            data: {
              breadcrumb: {
                currentSection: 'strategy'
              }
            }
          },
          {
            path: 'strategy-identification',
            component: LessonStrategyIdentificationComponent,
            data: {
              breadcrumb: {
                currentSection: 'strategy'
              }
            }
          },
          {
            path: 'strategy-answer',
            component: LessonStrategyAnswerComponent,
            data: {
              breadcrumb: {
                currentSection: 'strategy'
              },
              problemCase: 'strategyProblem'
            }
          },
          ...exerciseRoutes
        ]
      },
    ]
  },
];

